export interface TransactionTypeData {
  transaction_types?: {
    buckets: Array<{
      key: string
      doc_count: number
    }>
  }
  transaction_types_over_time?: {
    buckets: Array<{
      key_as_string: string
      key: number
      doc_count: number
      by_type?: {
        buckets: Array<{
          key: string
          doc_count: number
        }>
      }
    }>
  }
  total_value_by_type?: {
    buckets: Array<{
      key: string
      doc_count: number
      total_value: {
        value: number
      }
      avg_value: {
        value: number
      }
    }>
  }
}

export interface TransactionTypeChartProps {
  data?: TransactionTypeData
  loading?: boolean
  error?: string | null
  showKPIs?: boolean
  showTrends?: boolean
  onTypeClick?: (type: string) => void
  formatTransactionType?: (type: string) => string
  labels?: Partial<TransactionTypeChartLabels>
}

export interface ProcessedTypeData {
  key: string
  name: string
  value: number
  percentage: number
  color: string
}

export interface TransactionTypeChartLabels {
  totalTransactions?: string
  dominantType?: string
  totalVolume?: string
  averageValue?: string
  distributionTitle?: string
  trendsTitle?: string
}

export const DEFAULT_TRANSACTION_TYPE_CHART_LABELS: TransactionTypeChartLabels =
  {
    totalTransactions: 'Total Transactions',
    dominantType: 'Dominant Type',
    totalVolume: 'Total Volume',
    averageValue: 'Average Value',
    distributionTitle: 'Distribution by Transaction Type',
    trendsTitle: 'Temporal Evolution',
  }
